<template>
  <div class="modal fade show custom-modal" id="paymentShareLink" role="dialog" :class="{'modal-show':showModal}">
    <div class="modal-dialog modal-dialog-centered model-lg">
      <div class="modal-content">
        <div class="modal-head d-flex">
          <img src="@/assets/images/done.png" class="tick border-0 position-relative mt-3" />
        </div>
        <div class="modal-body text-center position-relative pb-0 pt-3">
          <p class="text-center portrait">Your payment link has been successfully shared at</p>
          <p class="font-weight-bold text-center">something@something.com</p>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 text-center d-flex justify-content-center mt-1 mb-4">
          <button type="button" class="btn bgc-btn-primary w-25" @click="closePaymentModal()" data-dismiss="modal"  id="payment-share-link-done">Done</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from '@vue/composition-api';
export default {
  name: "PaymentShareLink",
  props: ["showModal"],
  components: {
  },
  setup(props,context){
    let state = reactive({
    });
    //methods
    function closePaymentModal(){
      context.parent.closePaymentModal();
    }
    //return
    return{
      closePaymentModal
    }
  }
};
</script>

<style scoped>
.custom-modal {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  transform: scale(0);
}
.modal-show {
  display: block;
  transform: scaleY(0) scaleX(0);
  animation: unfoldIn 0.25s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
.modal-head{
    -ms-flex-negative:0;
    flex-shrink:0;
    margin: 28px 5px 12px 5px;
    justify-content:space-between;
}
.modal-body {
  overflow-y: hidden;
}
.btn:hover {
  color: #ffffff;
}
.tick {
  color: white;
  width: 45px;
  height: 45px;
  left: 46%;
}
@media (min-width: 375px) {
  .portrait {
    width: 100%;
  } 
}
@media (min-width: 360px) {
  .portrait {
    width: 100%;
  } 
}
</style>